<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :title="flag===1?'Esop变更编辑':'Esop变更新建'"
      top="2vh"
      width="1000px"
      @close="$reset('form')">
    <el-form
        ref="form"
        label-width="80px"
        :rules="ruleValidate"
        class="form"
        :model="esopVo">
      <el-row>
        <el-col :span="10">
          <el-form-item label="Esop编号" prop="esopNo">
            <el-input v-model="esopVo.esopNo" placeholder="请选择操作卡" readonly>
              <el-button slot="append"
                         icon="el-icon-search"
                         @click="selectEsop"
                         :disabled="flag===1"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="物料编号">
            <el-input v-model="esopVo.materialNo" readonly/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="物料名称">
            <el-input v-model="esopVo.materialName" readonly/>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="规格型号">
            <el-input v-model="esopVo.specification" readonly/>
          </el-form-item>
        </el-col>
      </el-row>
      <divider/>
      <div style="text-align: right;margin-left: 5px;">
        <el-button type="primary" style="margin-bottom:5px" @click="$refs.editPage.open(0)">上传附件</el-button>
      </div>
      <el-table :loading="tableLoading" :data="esopVo.changeDetailVOS" style="height: 400px;">
        <el-table-column label="附件" prop="imgPath" align="center" width="240">
          <template slot-scope="scope">
          <span style="cursor: pointer;color:#2d8cf0"
                @click="imgPreview(scope.row.imgPath)">{{scope.row.imgPath}}</span>
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="note" align="center"/>
        <el-table-column label="创建人" prop="creatorName" align="center" width="120"/>
        <el-table-column label="创建时间" prop="createTime" align="center" width="160"/>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.creatorId !== userId" type="primary"
                       @click="$refs.editPage.open(scope.row,scope.$index)">编辑
            </el-button>
            <el-button :disabled="scope.row.creatorId !== userId" type="danger" @click="deleteRow(scope.$index)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <file-upload ref="editPage" @save-success="editRow"/>
    <esop-select ref="esopInfoSelect" @select="selectEsopInfo"/>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit(0)">保存</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit(1)">提交</el-button>
    </span>
    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        @closeClick="
          () => {
            photoVisible = false
          }
        "/>
  </el-dialog>
</template>

<script>
  import fileUpload from "./FileUpload";
  import BigImg from "@/components/BigImg";
  import loginUtil from "@/util/loginUtil";
  import EsopSelect from "@/views/information/Esop/EsopSelect";

  export default {
    components: {
      fileUpload,
      BigImg,
      EsopSelect,
    },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        photoVisible: false,
        tableLoading: true,
        bigImgUrl: "",
        flag: 0,
        userId: loginUtil.getUserId(),
        pkId: "",
        esopVo: {
          esopNo: "",
          changeType: 30,
          approveType: 30,
        },
        ruleValidate: {
          esopNo: {required: true, message: "请选择操作卡"},
        },
      };
    },

    methods: {
      open(flag, id) {
        this.flag = flag;
        this.pkId = id;
        this.dialogVisible = true;
        if (flag === 1) {
          this.getData();
        }
      },

      getEsopChangeData() {
        this.$http.get("basic", `esopChanges/getByEsopId/${this.pkId}`).then((res) => {
          if (res.data) {
            this.esopVo = res.data;
            this.esopVo.changeDetailVOS = res.data.changeDetailVOS ? res.data.changeDetailVOS : [];
            this.esopVo.changeType = 30;
            this.esopVo.approveType = 30;
            this.esopVo.esopId = this.pkId;
            this.tableLoading = false;
          }
        });
      },

      getData() {
        this.$http.get("basic", `esopChanges/${this.pkId}`).then((res) => {
          if (res.data) {
            this.esopVo = res.data;
            this.esopVo.changeDetailVOS = res.data.changeDetailVOS ? res.data.changeDetailVOS : [];
            this.esopVo.changeType = 30;
            this.esopVo.approveType = 30;
            this.esopVo.esopId = this.pkId;
            this.tableLoading = false;
          }
        });
      },

      selectEsop() {
        this.$refs.esopInfoSelect.open();
      },
      selectEsopInfo(row) {
        this.esopVo.esopNo = row.esopNo;
        this.esopVo.esopId = row.pkId;
        this.esopVo.materialName = row.materialName;
        this.esopVo.materialNo = row.materialNo;
        this.esopVo.specification = row.specification;
        this.esopVo.changeType = 30;
        this.esopVo.approveType = 30;
        this.esopVo.changeDetailVOS = [];
      },

      showBigImage(e) {
        //点击图片函数，点击后，把photoVisible设置成true
        if (e != "") {
          this.photoVisible = true;
          this.bigImgUrl = e.currentTarget.src;
        }
      },

      deleteRow(index) {
        this.esopVo.changeDetailVOS.splice(index, 1);
      },

      editRow(row) {
        let rowInfo = {
          createTime: this.getNowTime(),
          creatorId: loginUtil.getUserId(),
          creatorName: loginUtil.getName(),
          note: row.note,
        };
        if (row.isCreated) {
          rowInfo.imgPath = row.imgPath;
          rowInfo.imgUrl = row.imgUrl;
          this.esopVo.changeDetailVOS.push(rowInfo);
        } else {
          if (row.imgPath && row.imgUrl) {
            this.esopVo.changeDetailVOS[row.index].imgUrl = row.imgUrl;
            this.esopVo.changeDetailVOS[row.index].imgPath = row.imgPath;
            this.esopVo.changeDetailVOS[row.index].note = row.note;
            this.esopVo.changeDetailVOS[row.index].createTime = this.getNowTime();
          }
        }

      },

      getUrl(imgPath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(imgPath)}`).then((res) => {
          if (res.success) {
            this.bigImgUrl = res.data;
            this.photoVisible = true;
          }
        });
      },

      getNowTime() {
        const yy = new Date().getFullYear();
        const MM = (new Date().getMonth() + 1) < 10 ? "0" + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
        const dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate();
        const HH = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
        const mm = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
        const ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
        return yy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss;
      },

      handleSubmit(type) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.esopVo.changeDetailVOS.length === 0) {
              this.$message.error("保存信息不能为空.");
              return;
            }
            this.$http.post("basic", `esopChanges/save1/${type}`, this.esopVo).then((res) => {
              if (res.success) {
                this.$message.success(type ? "提交成功" : "保存成功");
                this.dialogVisible = false;
              }
            });
          }
        });
      },

      imgPreview(path) {
        this.getUrl(path);
      },

      closePage() {
        this.esopVo = [];
      },
    },
  };
</script>

<style>

</style>